<template>
  <div class="container-wrapper">
    <!-- Header -->
    <web-header></web-header>
    <!-- <web-bg></web-bg> -->

    <!-- Content -->
    <router-view class="content"></router-view>
  </div>
</template>

<script>
import WebHeader from "../components/header.vue"; // Header

const defaultSettings = require("@/settings.js");
export default {
  name: "Home",
  components: {
    WebHeader
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route(to, from) {
      var title =
        defaultSettings.title + "-" + this.$store.state.metaInfo.title;
      let metaInfo = {
        title: title
      };
      this.$store.commit("CAHNGE_META_INFO", metaInfo);
    }
  },
  created() {
    if (this.$store.state.metaInfo.title !== undefined) {
      var title =
        defaultSettings.title + "-" + this.$store.state.metaInfo.title;
      let metaInfo = {
        title: title
      };
      this.$store.commit("CAHNGE_META_INFO", metaInfo);
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/home.vue